import { render, staticRenderFns } from "./coachWheel.vue?vue&type=template&id=321eaab6&scoped=true"
import script from "./coachWheel.vue?vue&type=script&lang=js"
export * from "./coachWheel.vue?vue&type=script&lang=js"
import style0 from "./coachWheel.vue?vue&type=style&index=0&id=321eaab6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321eaab6",
  null
  
)

export default component.exports